export const extractType = (type_string) => type_string.substring(4); // Extract only type name